import { BookOpenCheckIcon, CalculatorIcon, HashIcon, MessagesSquareIcon, WaypointsIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'ANSI Device Numbers & Protection Functions Quick Reference',
    description: 'A fast-lookup reference of IEEE device numbers, what each protection function does and where it is applied.',
    icon: HashIcon,
  },
  {
    number: '2',
    title: 'Single-Line Diagram Reading Guide',
    description: 'A step-by-step method to read real substation single-line diagrams, with symbols and guided exercises.',
    icon: WaypointsIcon,
  },
  {
    number: '3',
    title: 'Protection Coordination Worked Examples',
    description: 'Fully solved coordination exercises that show every calculation step.',
    icon: CalculatorIcon,
  },
  {
    number: '4',
    title: 'Substation Technical Glossary',
    description: 'An A–Z reference of the terms and acronyms used in substations, protection, control and testing.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '5',
    title: 'Protection & Control Interview Preparation Guide',
    description: 'Questions by topic, model answers and scenario questions to prepare for technical interviews.',
    icon: MessagesSquareIcon,
  },
];
